import Axios from 'axios';
import { OrderCircle_CONFIG } from '@/js/config.js';
const RESOURCE_NAME = OrderCircle_CONFIG.API_URL + 'brand-list';
const Brand_Detail = OrderCircle_CONFIG.API_URL + 'brand-detail';
const Brands_Report = OrderCircle_CONFIG.API_URL + 'brands-report';

export default {
	// equivalent to laravel's index method
	getAll() {
    return Axios.get(RESOURCE_NAME);
  },

	// equivalent to laravel's show method
  get(id) {
    return Axios.get(`${RESOURCE_NAME}/${id}`);
  },

  create(data) {
    return Axios.post(RESOURCE_NAME, data);
  },

  update(id, data) {
    return Axios.put(`${RESOURCE_NAME}/${id}`, data);
  },

  delete(id) {
    return Axios.delete(`${RESOURCE_NAME}/${id}`);
  },
	listingUrl() {
		return RESOURCE_NAME;
	},
  brandsReport() {
    return Brands_Report;
	},
	detailPageUrl(subdomain){
		// detail main page url is /dashboard/brands/subdomain
		return OrderCircle_CONFIG.SITE_URL + 'brand/' + subdomain;
	},
	// equivalent to laravel's show method
  getBrand(subdomain) {
    return Axios.get(`${Brand_Detail}/${subdomain}`);
  },
  
	loginAsBrandOwner(subdomain){
		return '/brands/' + subdomain + '/auto-login';
	},
  getBrandConnectedPaymentMethods(token) {
    let connectedPaymentsUrl = OrderCircle_CONFIG.API_URL + 'brand/connected-payment-methods';
    return Axios.get(`${connectedPaymentsUrl}`);
  },
  async changeBrandPlanTo(plan, subdomain, token){
    let patchPlanUrl = OrderCircle_CONFIG.API_URL +'settings/subscription/brand-plan/' + plan + '/' + subdomain;
    return await Axios.patch(`${patchPlanUrl}`, {})
  },
  getSubscriptions(subdomain, token) {
    let connectedPaymentsUrl = OrderCircle_CONFIG.API_URL + 'settings/brand/'+ subdomain +'/subscriptions';
    return Axios.get(`${connectedPaymentsUrl}`);
  },
  async createNewTrial(data, subdomain, token){
    let patchTrialPlanUrl = OrderCircle_CONFIG.API_URL +'settings/subscription/brand/new-trial-plan/' + subdomain;
    return await Axios.post(`${patchTrialPlanUrl}`, data)
  },
  async cancelSubscription(data) {
    let subdomain = data.subdomain;
    let cancelSubscriptionUrl = OrderCircle_CONFIG.API_URL +'settings/subscription/brand/cancel-stripe-subscription/' + subdomain;
    return await Axios.post(`${cancelSubscriptionUrl}`, data)
  },
  async extendCurrentTrial(data, subdomain, token){
    let patchTrialPlanUrl = OrderCircle_CONFIG.API_URL +'settings/subscription/brand/extend-trial/' + subdomain;
    return await Axios.post(`${patchTrialPlanUrl}`, data)
  },
  async removeBrand(data,token) {
    return await Axios.post(`${OrderCircle_CONFIG.API_URL}remove-brand`, data);
  },
  async enableDowngrade(data,token) {
    return await Axios.post(`${OrderCircle_CONFIG.API_URL}enable-downgrade`, data);
  },
  getCustomerContacts() {
    return OrderCircle_CONFIG.API_URL + "customer-contact";
  }
};
